import { toast as reactHotToast } from 'react-hot-toast'
import toastImgIcon from '../../assets/images/checkIcon.svg'
import closeToastIcon from '../../assets/images/closeToast.svg'
import removeIcon from '../../assets/images/removeIcon.svg'
import copyIcon from '../../assets/images/iconCopyLink.svg'
import crossIcon from '../../assets/images/crossIcon 1.svg'
import hideIcon from '../../assets/images/hideIcon.svg'
import hideIcon1 from '../../assets/images/Icon1.png'
import heart from '../../assets/images/heart.svg'

import star from '../../assets/images/star.png'


export const useToast = () => {
	return {
		success: (message) => {
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={toastImgIcon} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			))
		},
		cancel: (message) => {
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={crossIcon} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			))
		},
		error: (message) => {
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={removeIcon} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			))
		},
		star: (message) =>
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={star} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			)),

		copy: (message) =>
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={copyIcon} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			)),
		hide: (message) =>
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={hideIcon} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			)),
		unhide: (message) =>
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={hideIcon1} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			)),
		heart: (message) => {
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex'>
							<span>
								<img src={heart} alt='toastIcon' />
							</span>
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<img
									src={closeToastIcon}
									alt='closeToastIcon'
								/>
							</button>
						</div>
					</div>
				</div>
			))
		},
	}
}
